import React from 'react';
import '../css/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>
      <p>Last Updated: October 23, 2024</p>
      
      <h2>1. Introduction</h2>
      <p>Welcome to Solar Revenue Calculator.We are dedicated to protecting your privacy and ensuring the security of any information you provide while using our solar panel installation calculator application ("Service"). This Privacy Policy outlines how we handle your data and the measures we take to safeguard your privacy.</p>
      
      <h2>2. Information We Collect</h2>
      <h3>a. Personal Information</h3>
      <p>Monthly Electricity Usage: We temporarily store your average monthly electricity usage directly in your browser's session storage. This data is used solely to enhance the functionality of the calculator and provide you with accurate estimates for solar panel installation.</p>
      <h3>b. Non-Personal Information</h3>
      <p>We do not collect any non-personal information such as browser type, IP address, or usage data.</p>
      <h3>c. Data Collection Methods</h3>
      <p>The data is collected through the solar panel calculator form within the application and is stored only in your browser's session storage. No data is transmitted to our servers, cloud storage, or any third-party services.</p>
      
      <h2>3. Purpose of Data Collection</h2>
      <h3>a. Service Provision</h3>
      <p>The primary purpose of collecting your monthly electricity usage is to provide you with personalized and approximate figures that assess the value of solar panel installation for your specific situation.</p>
      <h3>b. Communication</h3>
      <p>We do not use your information to communicate with you via newsletters, updates, or support services.</p>
      <h3>c. Analytics</h3>
      <p>We do not analyze your data to understand usage patterns or for any analytical purposes.</p>
      
      <h2>4. Data Sharing and Disclosure</h2>
      <h3>a. Third-Party Sharing</h3>
      <p>We do not share, sell, or disclose your information with any third parties. All data remains confined to your browser session.</p>
      <h3>b. Legal Requirements</h3>
      <p>We do not disclose your data unless required to do so by law. However, given that we do not store any personal information beyond your browser session, such scenarios are highly unlikely.</p>
      
      <h2>5. Data Storage and Security</h2>
      <h3>a. Storage Locations</h3>
      <p>All data is stored locally in your browser's session storage. This means the information is retained only for the duration of your browser session and is cleared once the session ends.</p>
      <h3>b. Security Measures</h3>
      <p>Since the data is stored locally and not transmitted or stored on our servers, additional security measures are not required. However, we recommend that you manage your browser's security settings to protect your session data.</p>
      
      <h2>6. User Rights and Choices</h2>
      <h3>a. Access and Correction</h3>
      <p>You have complete control over the data stored in your browser session. If you wish to delete your monthly electricity usage data, you can do so by clearing your browser's session storage.</p>
      <h3>b. Data Deletion</h3>
      <p>To remove your data, simply clear your browser's session data through your browser settings.</p>
      <h3>c. Opt-Out Options</h3>
      <p>As we do not collect or store data beyond your browser session and do not engage in data sharing or communications, additional opt-out measures are not necessary.</p>
      
      <h2>7. Use of Cookies and Tracking Technologies</h2>
      <h3>a. Cookies</h3>
      <p>We do not use cookies or any similar tracking technologies in our application.</p>
      <h3>b. Purpose of Cookies</h3>
      <p>Not applicable, as no cookies are used.</p>
      
      <h2>8. Children's Privacy</h2>
      <h3>a. Age Restrictions</h3>
      <p>Our Service is not intended for use by children under the age of 13. We do not knowingly collect personal information from children.</p>
      
      <h2>9. Compliance with Laws and Regulations</h2>
      <h3>a. Applicable Laws</h3>
      <p>We do not collect or store information that falls under the scope of privacy laws such as the General Data Protection Regulation (GDPR). However, users accessing our Service from jurisdictions with specific privacy laws should consult their local regulations.</p>
      
      <h2>10. Changes to This Privacy Policy</h2>
      <h3>a. Policy Updates</h3>
      <p>We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. Any updates that require user consent will be presented via a permissions pop-up within the Service. All changes will be visible on the Privacy Policy page.</p>
      
      <h2>11. Contact Information</h2>
      <h3>a. Privacy Inquiries</h3>
      <p>If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at:</p>
      <p>Email: home@salientapplications.uk</p>
      
      <p><strong>Disclaimer:</strong> The results provided by our calculator are estimates only and may vary based on individual circumstances. For precise information and personalized advice, please consult a certified solar energy provider.</p>
    </div>
  );
};

export default PrivacyPolicy;
